'use strict';

var ArctickClient = require('../apiClient');
var util = require('util');

function Users() {
    ArctickClient.apply(this, arguments);
}

util.inherits(Users, ArctickClient);

Users.prototype.getCurrentUser = function(token, callback) {
    if (token == null || token === '') {
        callback(null, null);
        return;
    }
    this.setAccessToken(token);
    this._makeRequest({
        method: 'GET',
        path: '/api/v2/users',
        params: {
            includes: 'MerchantOwnerID,AccountOwnerID,UserLogins'
        }
    }, callback);
};

Users.prototype.getUserDetails = function(options, callback) {
    const self = this;

    const excludeToken = options.excludeToken || false;
    const token = !excludeToken ? options.token : null;
    var userId = options.userId;
    const includes = options.includes || '';
    const includeUserCustomFields = true//options.includeUserCustomFields || false;

    if (typeof window !== "undefined") {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const pagination = urlParams.get('pagination')

        if(pagination) {
            if(document.getElementById('regresarPagination')) {
                if(!document.getElementById('regresarPagination').href.includes('pagination')) {
                    var newHref =  document.getElementById('regresarPagination').href + "?pagination=" + pagination;
                    document.getElementById('regresarPagination').href = newHref;
                }
            }
        }
    }
    if (token || excludeToken) {
        this.setAccessToken(token);
        self._makeRequest({
            method: 'GET',
            path: '/api/v2/users/' + userId,
            params: {
                includes: includes,
                includeUserCustomFields: includeUserCustomFields
            }
        }, callback);
    } else {
        self._acquireAdminAccessToken(function () {
            if(userId.includes('00000000') && (process.env.BASE_URL == "bepensab2c.staging.arcadier.io" || process.env.BASE_URL == "bepensab2c.sandbox.arcadier.io" || process.env.BASE_URL == "bepensademo.sandbox.arcadier.io")){
                userId = "d500bd4d-d8ff-4b84-8bf2-8e1bdbd444a1";
            } else if(userId.includes('00000000') && process.env.BASE_URL == "bepensa.arcadier.io"){
                userId = "b1f6a947-5716-475d-87e5-8be4d3198ce6";
            }
            self._makeRequest({
                method: 'GET',
                path: '/api/v2/users/' + userId,
                params: {
                    includes: includes,
                    includeUserCustomFields: includeUserCustomFields
                }
            }, callback);
        });
    }
};

Users.prototype.getUserLogins = function(userId, callback) {
    const self = this;
    self._acquireAdminAccessToken(function() {
        self._makeRequest({
            method: 'GET',
            path: '/api/v2/users/' + userId,
            params: {
                includes: 'UserLogins'
            }
        }, callback);
    });
};

Users.prototype.updateUser = function (userId, userInfo, callback) {
    const self = this;
    self._acquireAdminAccessToken(function() {
        self._makeRequest({
            method: 'PUT',
            path: '/api/v2/users/' + userId,
            data: userInfo
        }, callback);
    });
};

Users.prototype.getAnalyticsApiAccess = function (options, callback) {
    const self = this;
    const merchantId = options.merchantId;

    self._acquireAdminAccessToken(function () {
        self._makeRequest({
            method: 'GET',
            path: '/api/v2/merchants/' + merchantId + '/analytics'
        }, callback);
    });
};

Users.prototype.getUsers = function(options, callback) {
    const self = this;
    const keyword = options.keyword;
    const role = options.role;
    const pageSize = options.pageSize;
    const findExact = options.findExact;

    self._acquireAdminAccessToken(function(err, data) {
        if (!err) {
            self._makeRequest({
                method: 'GET',
                path: '/api/v2/admins/' + data.UserId + '/users/',
                params: {
                    keywords: keyword,
                    role: role,
                    findExact: findExact,
                    pageSize : pageSize
                }
            }, callback);
        }
    });
};

Users.prototype.mergeGuestToUser = function (options, callback) {
    const self = this;
    const userID = options.userId;
    const guestUserID = options.guestUserId;
    const returnUrl = options.returnUrl;

    self._acquireAdminAccessToken(function (err, data) {
        if (!err) {
            self._makeRequest({
                method: 'POST',
                path: '/api/v2/accounts/merge-data',
                params: {
                    guestUserId: guestUserID,
                    userId: userID
                }
            }, callback);
        }
    });
};

Users.prototype.registerSubAccountInvitations = function (options, callback) {
    const self = this;

    const userId = options.userId;
    const data = JSON.parse(options.invitations).map((invitation) => {
        return {
            Name: invitation.name,
            Email: invitation.email,
            RegistrationType: options.registrationType
        }
    });

    self._acquireAdminAccessToken(function () {
        self._makeRequest({
            method: 'POST',
            path: '/api/v2/users/' + userId + '/sub-accounts/invites',
            data: data
        }, callback);
    });
};

Users.prototype.getSubAccounts = function (options, callback) {
    const self = this;

    const userId = options.userId;
    const pageSize = options.pageSize;
    const pageNumber = options.pageNumber;
    const keyword = options.keyword;

    self._acquireAdminAccessToken(function () {
        self._makeRequest({
            method: 'GET',
            path: '/api/v2/users/' + userId + '/sub-accounts',
            params: {
                pageSize: pageSize,
                pageNumber: pageNumber,
                keyword: keyword,
                sort: 'username',
                includes: 'AccountOwner'
            }
        }, callback);
    });
};

Users.prototype.deleteSubAccount = function (options, callback) {
    const self = this;

    const userId = options.userId;
    const subAccountUserId = options.subAccountUserId;

    self._acquireAdminAccessToken(function () {
        self._makeRequest({
            method: 'DELETE',
            path: '/api/v2/users/' + userId + '/sub-accounts/' + subAccountUserId
        }, callback);
    });
};

Users.prototype.getAllUsers = function (options, callback) {
    const self = this;

    self._acquireAdminAccessToken(function (err, data) {
        self._makeRequest({
            method: 'GET',
            path: '/api/v2/admins/' + data.UserId + '/users',
            params: {
                pageSize: options.pageSize,
                pageNumber: options.pageNumber,
                role: options.role,
                sort: options.sort
            }
        }, callback);
    });
}

module.exports = Users;